// extracted by mini-css-extract-plugin
export var labelWrapper = "_cu-0";